import React from 'react';
import { Box } from '@mui/material';

import { TruckloadGrid } from './TruckloadGrid';

export function Truckloads() {
  return (
    <Box sx={{ flexGrow: 1, height: 'inherit' }}>
      <TruckloadGrid />
    </Box>
  );
}
